import { ConfigService, VoucherService } from '../../services';
import { Spinner } from '../../services';
import { Alert } from '../../services';
import React, { useState, useEffect } from 'react';
import Pagination from '../../components/Pagination';
import { useParams } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import NoDataFound from '../../components/NoDataFound';
import TableComponent from '../../components/TableComponent';
const VoucherUtilization = () => {
  const [isPagination, setPagination] = useState({
    totalPages: 10,
    currentPage: 1,
  });

  let params = useParams();
  let voucherId = params ? params.id : null;
  const [voucherUtilizationList, setVoucherUtilizList] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [filterData, setFilterData] = useState({
    perPage: 10,
    page: 1,
    voucher_id: voucherId,
  });

  const tableConfig = {
    columns: {
      used_by: {
        title: 'Used By',
        render: (data) => {
          return data.user ? data.user.full_name : '';
        },
      },
      token_utilized: {
        title: 'Token Utilized',
        render: (data) => {
          return data?.tokens_utilized;
        },
      },
      fiat_transaction_id: {
        title: 'Fiat Transaction Id',
        render: (data) => {
          return data?.fiatTransactions?.transactions_id || 'NA';
        },
      },
      applied_on: {
        title: 'Applied On',
        render: (data) => {
          return ConfigService.dateFormat(data?.created_at, true);
        },
      },
    },
    data: voucherUtilizationList,
  };

  useEffect(() => {
    (async () => {
      await getList();
    })();
  }, [filterData]);

  const getList = async () => {
    try {
      setLoader(true);
      let _response = await VoucherService.getVoucherUtilizationList(
        filterData.perPage,
        filterData.page,
        voucherId,
      );

      if (_response.status === 'failure') {
        Spinner.hide();
        setLoader(false);
        Alert.error(_response.message);
        return false;
      }
      Spinner.hide();

      setPagination({
        totalPages: _response.data.pagination.totalPages,
        currentPage: _response.data.pagination.page,
      });
      setVoucherUtilizList([..._response.data.records]);
      setLoader(false);
    } catch (error) {
      Spinner.hide();
      setLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  const handlePagination = (current) => {
    setPagination({ ...isPagination, currentPage: current });
    setFilterData({
      ...filterData,
      page: current,
    });
  };

  return (
    <>
      <div className="flex flex-col relative overflow-x-auto">
        <TableComponent
          tableConfig={tableConfig}
          isListLoader={isLoader}
          isList={voucherUtilizationList}
        />
        {voucherUtilizationList &&
          voucherUtilizationList.length > 0 &&
          isLoader === false && (
            <Pagination
              total={isPagination.totalPages}
              current={isPagination.currentPage}
              pagination={(crPage) => handlePagination(crPage)}
            />
          )}
        {voucherUtilizationList &&
          voucherUtilizationList.length === 0 &&
          isLoader === false && (
            <>
              <NoDataFound />
            </>
          )}
      </div>
    </>
  );
};
export default VoucherUtilization;
